import Raven from 'raven-js';
let audioContextInstance = null;
export async function getAudioContext() {
  if (!audioContextInstance) {
    if (window.AudioContext) {
      audioContextInstance = new AudioContext();
    } else if ('webkitAudioContext' in window) {
      audioContextInstance = new window.webkitAudioContext();
    } else if ('mozAudioContext' in window) {
      audioContextInstance = new window.mozAudioContext();
    } else if ('oAudioContext' in window) {
      audioContextInstance = new window.oAudioContext();
    } else if ('msAudioContext' in window) {
      audioContextInstance = new window.msAudioContext();
    } else {
      audioContextInstance = null;
    }
  } else {
    if (audioContextInstance.state === 'suspended') {
      try {
        await audioContextInstance.resume();
      } catch (e) {
        if (e instanceof Error) {
          Raven.captureException(new Error('Unable to resume AudioContext', e));
        }
      }
    }
  }
  return audioContextInstance;
}

/**
 * Only for tests to clear singleton instance
 */
export const resetAudioContextInstance = () => {
  audioContextInstance = null;
};